'use strict';

angular.module('shiftTraderApp')
    .directive('saDaysOffSummaryDay', ['TimeService', 'DayOffLimitStore', 'ViewDayOffDayHistoryModalService', function (TimeService, DayOffLimitStore, ViewDayOffDayHistoryModalService) {
      return {
        templateUrl: 'views/daysOff/saDaysOffSummaryDay.html',
        restrict: 'A',
        scope: {
          focusFn: '&',
          day: '=saDaysOffSummaryDay',
          mode: '@'
        },
        link: function(scope, elem) {
          scope.focusOnDay = function(arg) {
            return scope.focusFn()(arg);
          };

          scope.state = {
            mode: {
              pending: scope.mode === 'pending',
              report: scope.mode !== 'pending'
            }
          };

          scope.state.numPending = _.where(scope.day.items, function(dayOff) {
            return dayOff.$isPending();
          }).length;

          scope.state.expiredDaysOff = _.where(scope.day.items, function(dayOff) {
            return dayOff.$isExpired();
          });

          scope.state.approvedDaysOff = _.where(scope.day.items, function(dayOff) {
            return dayOff.$isApproved();
          });

          scope.state.disapprovedDaysOff = _.where(scope.day.items, function(dayOff) {
            return dayOff.$isDisapproved();
          });

          scope.state.isInThePast = TimeService.getBeginningOfDayFromDateWithOrgSetting(moment()).isAfter(scope.day.range_twix.start);

          function setLimitClass() {
            var cls = 'no-limit';

            if (scope.state.limitRecord) {
              if (scope.state.approvedDaysOff.length > scope.state.limitRecord.limit) {
                cls = 'over-limit';
              } else if ((scope.state.approvedDaysOff.length + scope.state.numPending) > scope.state.limitRecord.limit) {
                cls = 'limit-at-risk';
              } else if ((scope.state.approvedDaysOff.length + scope.state.numPending) < scope.state.limitRecord.limit) {
                cls = 'under-limit';
              } else if ((scope.state.approvedDaysOff.length + scope.state.numPending) === scope.state.limitRecord.limit) {
                cls = 'at-limit';
              }
            }
            return cls;
          }

          if (scope.state.mode.report) {
            DayOffLimitStore.getLimitForDate(scope.day.range_twix.start)
              .then(function(limitRecord) {
                scope.state.limitRecord = limitRecord;
                scope.state.limitClass = setLimitClass();
              }, function() {
                console.log('had an issue loading the limit');
              })

          }

          scope.openDayOffLimitHistoryDayModal = function(day) {
            ViewDayOffDayHistoryModalService.openModal(day.range_twix.start);
          };

        }
      };
    }]);
